/* Feedback entry points for both builders (Standard and I9 System).
 * Tiny, always loaded: wires the "Send feedback or report a problem" link at the bottom of the builder and gives the Studio
 * (through assets/i9-system.js, config.onFeedbackRequest) one function to call. The popup itself (assets/feedback-popup.js
 * + .css) is fetched on the first click only, so builder pages stay as light as before. The asset URLs come from the
 * script tag's data attributes (sections/section-variant-builder.liquid).
 *   window.LoamFeedback.open(openerElement)  -> Promise
 */
(function (global) {
  'use strict';
  var me = document.currentScript || document.querySelector('script[data-popup-js]');
  var urls = { js: me ? me.getAttribute('data-popup-js') : null, css: me ? me.getAttribute('data-popup-css') : null };
  var FORM_URL = 'https://form-builder-dn.pifyapp.com/form/s/8883';
  var loading = null;
  function load() {
    if (global.LoamFeedbackPopup) return Promise.resolve(global.LoamFeedbackPopup);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      if (!urls.js) { reject(new Error('feedback popup asset URL missing')); return; }
      if (urls.css && !document.querySelector('link[data-loam-feedback-css]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = urls.css; l.setAttribute('data-loam-feedback-css', '1'); document.head.appendChild(l);
      }
      var s = document.createElement('script'); s.src = urls.js; s.async = true;
      s.onload = function () { if (global.LoamFeedbackPopup) resolve(global.LoamFeedbackPopup); else { loading = null; reject(new Error('feedback popup did not initialise')); } };
      s.onerror = function () { loading = null; reject(new Error('feedback popup script failed to load')); };
      document.head.appendChild(s);
    });
    return loading;
  }
  // opener: the link that was clicked; focus returns to it when the popup closes.
  function open(opener) {
    var o = opener || document.activeElement;
    return load().then(function (api) { api.open(o); return api; }).catch(function (e) {
      if (global.console) global.console.warn('[feedback] ' + e.message + '; opening the form in a new tab');
      global.open(FORM_URL, '_blank', 'noopener');
      return null;
    });
  }
  global.LoamFeedback = { open: open, load: load };
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.builder-feedback-link') : null; if (!a) return;
    e.preventDefault();
    open(a);
  });
  // The Custom Order Policy sentence (with the feedback link beside it) is part of Step 3's markup, so on Steps 1 and 2 the same
  // link sits in its own row at the bottom of the builder; CSS hides that row while Step 3 is shown, so the link appears once per step.
  function addBottomRow() {
    var container = document.getElementById('variant-builder-container'); if (!container || container.querySelector('.builder-feedback-row')) return;
    var row = document.createElement('div'); row.className = 'builder-feedback-row';
    row.innerHTML = '<a href="#" class="builder-feedback-link">Send feedback or report a problem</a>';
    container.appendChild(row);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addBottomRow); else addBottomRow();
})(window);
